import { Users } from "lucide-react";
import { EmptyState } from "@/components/shared/empty-state";
import { PageHeader } from "@/components/shared/page-header";

export function TeamPlaceholderPage({ team }: { team: string }) {
  return (
    <div className="space-y-6 p-6">
      <PageHeader title={team} description={`${team} team dashboard`} />
      <EmptyState
        icon={Users}
        heading="Coming soon"
        description={`The ${team} team dashboard is being built. Check back soon.`}
      />
    </div>
  );
}
